import { render, staticRenderFns } from "./hangYe.vue?vue&type=template&id=01c3992b&scoped=true"
import script from "./hangYe.vue?vue&type=script&lang=js"
export * from "./hangYe.vue?vue&type=script&lang=js"
import style0 from "./hangYe.vue?vue&type=style&index=0&id=01c3992b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c3992b",
  null
  
)

export default component.exports